/*
 * 企业集团
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/group-solution';

const Group = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="企业集团解决方案"
      simpleDesc="智能云会议 高效云协同"
      desc={`小鱼易连通过“高安全·超融合·全连接”的云视频整体解决方案，深度融合企\n业集团业务需求，可高效支撑企业远程会议、协同办公、视频客服等日常或\n定制场景应用，赋能企业集团数字化转型升级。`}
      pageTitle="企业集团"
      tdkWord="group"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default Group;
